/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromotionDto
 */
export interface PromotionDto {
    /**
     * 
     * @type {number}
     * @memberof PromotionDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PromotionDto
     */
    type: PromotionDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromotionDto
     */
    nameEn: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionDto
     */
    nameAr: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PromotionDto
     */
    endsAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PromotionDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PromotionDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const PromotionDtoTypeEnum = {
    DeliveryFeeWaiver: 'DELIVERY_FEE_WAIVER'
} as const;
export type PromotionDtoTypeEnum = typeof PromotionDtoTypeEnum[keyof typeof PromotionDtoTypeEnum];


/**
 * Check if a given object implements the PromotionDto interface.
 */
export function instanceOfPromotionDto(value: object): value is PromotionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PromotionDtoFromJSON(json: any): PromotionDto {
    return PromotionDtoFromJSONTyped(json, false);
}

export function PromotionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'],
        'active': json['active'],
        'endsAt': (json['endsAt'] == null ? null : new Date(json['endsAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function PromotionDtoToJSON(value?: PromotionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'active': value['active'],
        'endsAt': (value['endsAt'] == null ? null : (value['endsAt'] as any).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

